import { useContrastMutation } from '../../../hooks/use-contrast-mutation'
import { editSourceName, EditSourceNameArgs } from './requests/edit-source-name'
import { UseMutationOptions } from 'react-query'
import { BaseApiResponse } from '../../../api/shared'
import { HTTPError } from '../../../api/fetch/decorate-fetch'

export const useEditSourceName = (
  options: UseMutationOptions<BaseApiResponse, HTTPError, EditSourceNameArgs>
) => {
  return useContrastMutation<BaseApiResponse, HTTPError, EditSourceNameArgs>(
    editSourceName,
    { ...options }
  )
}
